<template>
  <div class="view-container">
    <div class="card staff-table">
      <div class="card-header card-header-divider">
        <div class="card-title  display--flex">
            Архив пользователей
          <div class="popper_wrapper">
            <Popper placement="bottom" arrow class="products-popper">
              <div class="info_block">
                <img src="@/assets/images/icons/aboutProduct.svg" alt="Информация" width="20" height="20"/>
              </div>
              <template #content>
                <span>Раздел сотрудников, которые более не работают в компании или были переведены в другое подразделение. Данные сохраняются для аналитики и истории.</span>
              </template>
            </Popper>
          </div>
        </div>
      </div>
      <div class="card-body">
        <staff-deactivated-table />
      </div>
    </div>
  </div>
</template>

<script>
import ExcelLoadRow from "@/feature/users/ExcelLoadRow.vue";
import StaffTable from "@/feature/users/StaffTable.vue";
import { ref } from "@vue/reactivity";
import useCheckRights from "../../mixins/useCheckRights";
import StaffDeactivatedTable from "@/feature/users/DeactivatedStaffTable.vue";

export default {
  components: {StaffDeactivatedTable, ExcelLoadRow },
  name: "staff-deactivated-page",
  setup() {
    const showLoadForm = ref(false);
    const { getRight } = useCheckRights();

    return {
      showLoadForm,
      getRight,
    };
  },
};
</script>

<style>
.popper_wrapper {
  margin-left: 5px;
}
.btn-accent {
  margin-left: 15px;
}
.tools .add_user_btn {
  line-height: inherit;
}
</style>

<style lang="scss">
.products-popper .popper {
  background-color: #ffffff;
  font-size: 12px;
}
</style>